module.exports = __webpack_public_path__ + "img/未命名-1.d72801c0.png";